import { Link } from "@repo/ui/Link/routerLink";
import { IconArrowLeft } from "@tabler/icons-react";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export interface WorkspaceBackLinkProps {
  href: string;
}

export const WorkspaceBackLink: FC<WorkspaceBackLinkProps> = ({ href }) => (
  <Link
    href={href}
    className={twMerge(
      "flex w-fit items-center gap-1.5 rounded-md px-2 py-1 text-sm leading-5 font-medium text-sidebar-foreground transition-colors",
      "hover:text-foreground focus:outline-none focus-visible:ring-2 focus-visible:ring-primary",
    )}
  >
    <IconArrowLeft aria-hidden className="size-4 shrink-0" />
    <span className="min-w-0 truncate">Back</span>
  </Link>
);
